"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 10.002,
  cy: 10.002,
  r: 6.3,
  fill: "var(--sds--ursa-icons--background-color, transparent)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "ursa-icon__75ec61e0a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.897 4.262a.7.7 0 0 1 .7.7v2.025a.7.7 0 0 1-.7.7H13.87a.7.7 0 1 1 0-1.4h1.326V4.962a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 10a7 7 0 0 1 13.148-3.348.7.7 0 1 1-1.229.67A5.6 5.6 0 1 0 15.6 10a.7.7 0 1 1 1.4 0 7 7 0 0 1-14 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 11.2a.7.7 0 0 1-.7-.7V7.49a.7.7 0 0 1 1.4 0v3.01a.7.7 0 0 1-.7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.2 12.7a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.897 4.262a.7.7 0 0 1 .7.7v2.025a.7.7 0 0 1-.7.7H13.87a.7.7 0 1 1 0-1.4h1.326V4.962a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 10a7 7 0 0 1 13.148-3.348.7.7 0 1 1-1.229.67A5.6 5.6 0 1 0 15.6 10a.7.7 0 1 1 1.4 0 7 7 0 0 1-14 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 11.2a.7.7 0 0 1-.7-.7V7.49a.7.7 0 0 1 1.4 0v3.01a.7.7 0 0 1-.7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.2 12.7a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.197 6.287v1.4a1.4 1.4 0 0 0 1.4-1.4zm.951.365-1.229.67zm-1.229.67 1.229-.67zM9.3 10.5h1.4zm.7.7v1.4zm-.7-3.71H7.9zm1.4 0H9.3zm0 3.01h1.4zm-1.5 2.2H7.8zm.8-.8v1.4zm.8.8H9.4zm-.8.8v1.4zm7.997-8.538a2.1 2.1 0 0 0-2.1-2.1v2.8a.7.7 0 0 1-.7-.7zm0 2.025V4.962h-2.8v2.025zm-2.1 2.1a2.1 2.1 0 0 0 2.1-2.1h-2.8a.7.7 0 0 1 .7-.7zm-2.026 0h2.026v-2.8H13.87zm-2.1-2.1c0 1.16.94 2.1 2.1 2.1v-2.8a.7.7 0 0 1 .7.7zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1h2.8a.7.7 0 0 1-.7.7zm1.326 0h-1.325v2.8h1.325zm-1.4.075v1.325h2.8V4.962zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1h2.8a.7.7 0 0 1-.7.7zM10 1.6A8.4 8.4 0 0 0 1.6 10h2.8A5.6 5.6 0 0 1 10 4.4zm7.377 4.381A8.4 8.4 0 0 0 10 1.6v2.8a5.6 5.6 0 0 1 4.919 2.922zm-.838 2.85a2.1 2.1 0 0 0 .838-2.85l-2.458 1.341a.7.7 0 0 1 .28-.95zm-2.849-.838a2.1 2.1 0 0 0 2.85.838l-1.342-2.458a.7.7 0 0 1 .95.279zM10 5.8c1.59 0 2.975.882 3.69 2.193l2.458-1.341A7 7 0 0 0 10 3zM5.8 10A4.2 4.2 0 0 1 10 5.8V3a7 7 0 0 0-7 7zm4.2 4.2A4.2 4.2 0 0 1 5.8 10H3a7 7 0 0 0 7 7zm4.2-4.2a4.2 4.2 0 0 1-4.2 4.2V17a7 7 0 0 0 7-7zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1H17a.7.7 0 0 1-.7.7zm2.1 2.1a2.1 2.1 0 0 0-2.1-2.1v2.8a.7.7 0 0 1-.7-.7zM10 18.4a8.4 8.4 0 0 0 8.4-8.4h-2.8a5.6 5.6 0 0 1-5.6 5.6zM1.6 10a8.4 8.4 0 0 0 8.4 8.4v-2.8A5.6 5.6 0 0 1 4.4 10zm6.3.5c0 1.16.94 2.1 2.1 2.1V9.8a.7.7 0 0 1 .7.7zm0-3.01v3.01h2.8V7.49zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1h2.8a.7.7 0 0 1-.7.7zm2.1 2.1a2.1 2.1 0 0 0-2.1-2.1v2.8a.7.7 0 0 1-.7-.7zm0 3.01V7.49H9.3v3.01zM10 12.6a2.1 2.1 0 0 0 2.1-2.1H9.3a.7.7 0 0 1 .7-.7zm.6.1a.6.6 0 0 1-.6.6v-2.8a2.2 2.2 0 0 0-2.2 2.2zm-.6.6a.6.6 0 0 1-.6-.6h2.8a2.2 2.2 0 0 0-2.2-2.2zm-.6-.6a.6.6 0 0 1 .6-.6v2.8a2.2 2.2 0 0 0 2.2-2.2zm.6-.6a.6.6 0 0 1 .6.6H7.8a2.2 2.2 0 0 0 2.2 2.2z",
  mask: "url(#ursa-icon__75ec61e0a)"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SyncWarningIcon20.js.map